<template>
<div>
  <h1 class="section-title m-4 text-center text-lg">お出かけ情報サービス利用規約</h1>
  <div class="p-4 border-b border-section_border bg-white">
  <h2 class="font-bold text-link_darker">はじめに</h2>
  <p>「お出かけ情報サービス」（以下、「本サービス」といいます。）は、調布市が構築し、多摩市、京王電鉄株式会社が連携して提供するサービスです。お出かけ情報サービス利用規約（以下、「本規約」といいます。）は、本サービスの利用条件等を定めるものです。</p>
  <h2 class="font-bold text-link_darker">１．定義</h2>
  <p>本規約においては、次の用語はそれぞれ次の意味で使用します。<br />
(1) 「管理者」とは、本サービスを管理・運営する調布市、多摩市、京王電鉄株式会社、の３者を総じていいます。調布市は管理者を代表し、本サービスに関する変更、中断、廃止その他の権利を保有します。<br />
(2) 「ユーザ」とは、本サービスを利用される方を言います。<br />
(3) 「個別サービス」とは、本サービスを介して管理者又は管理者以外の第三者が提供する個々のコンテンツ及びサービスを言います。<br />
(4) 「個別サービス事業者」とは、個別サービスを提供する事業者を言います。<br />
(5) 「コンテンツ」とは、本サービスを構成するソフトウェア及びデータ、文章とそれらを構成する文字及び記号、音声とそれを構成する音及び音楽、写真及びイラスト等の画像、動画等の映像をいいます。<br />
(6) 「操作情報」とは、ユーザが本サービスを利用する際の操作内容及びその結果をいいます。<br />
(7) 「利用履歴」とは、本サービスにアクセスされたユーザの情報をいいます。具体的にはアクセスに要した機器及びインターネットプロバイダーの情報であり、ドメイン名やIPアドレス、使用しているブラウザの種類、アクセス日時等を含みます。<br />
(8) 「位置情報」とは、本サービス対応端末に搭載されるGPS機能で取得した緯度・経度情報及び基地局の情報（GPS機能を有していない本サービス対応端末の場合は、基地局の情報のみを用います。）を指します。
</p>
<h2 class="font-bold text-link_darker">２．本規約の適用範囲</h2>
<p>(1) 本規約は、ユーザと管理者との関係一切に適用されます。本規約の内容に同意しない場合、本サービスを利用することはできません。<br />
(2) 個別サービス事業者は、個別サービス上で提供される各種コンテンツの利用条件や利用上の注意事項等を、本規約によるもののほかに、個別サービスの利用規約で定めることができるものとします。
</p>
<h2 class="font-bold text-link_darker">３．規約の変更</h2>
<p>管理者は、本サービス上で変更内容と効力発生時期を事前に告知した上で、ユーザの承諾なく本規約を変更できるものとします。本規約の変更が効力を生じた後にユーザが本サービスを利用した場合、ユーザは変更後の本規約の全ての記載内容に同意したものとみなします。
</p>
<h2 class="font-bold text-link_darker">４．本サービスの利用（環境、料金・通信料等）について</h2>
<p>(1) ユーザは、本サービス対応端末を自らの責任と負担において用意し利用するものとします。<br />
(2) 端末により、本サービス又は個別サービスの機能が正しく作動しない場合、及びそれがもたらす諸影響に関して、管理者は一切の責任を負いません。<br />
(3) ユーザは、利用端末機器の性能等によって、本サービスの機能の一部又は全部を利用できない場合があることを承諾し、これに異議を述べないものとします。<br />
(4) 本サービスは、別途利用料金が必要な旨明記されていない限り、無償にて提供します。 ただし、本サービスの利用にあたって発生する通信料等は、ユーザが全額負担するものとします。 
</p>
<h2 class="font-bold text-link_darker">５．個別サービスの利用について</h2>
<p>(1) サービスは、当該個別サービスに係る利用規約に従って提供されます。<br />
(2) ユーザが個別サービスを利用する場合、本規約とは別に、個別サービス利用規約に基づく個別サービスの利用に関する契約が、ユーザと個別サービス事業者との間で成立します。<br />
(3) 各個別サービスの利用、その取消し、及び契約不適合責任等、また、個別サービスの利用に利用料金・代金等（以下「利用料金等」といいます。）が発生する場合の利用料金等の額、その算定方法及び支払方法並びに、払戻し等の額、その算定方法及び支払方法等は、各個別サービスに係る利用規約の定める内容に従うものとし、その変更についても同様とします。<br />
(4) 個別サービスの利用において、本規約の定めと当該個別サービスに係る利用規約の内容が異なる場合には、個別サービスに係る利用規約の内容が優先されるものとします。
</p>
<h2 class="font-bold text-link_darker">６．取得情報の取り扱いと利用目的</h2>
<p>(1) 管理者は、本サービスの利用に伴い以下の各号のユーザに関する情報（以下、「取得情報」といいます。）を取得します。<br />
ア ユーザが使用する本サービス対応端末のGPS機能により取得される位置情報<br />
イ 本サービス及び個別サービスにおいてユーザが入力又は検索した結果に基づく、目的地及び移動手段、移動経路などユーザの移動に関する情報<br />
(2) 管理者は、取得情報を以下の目的のために利用します。<br />
ア 本サービスを提供するため<br />
イ 本サービスの利用状況等に関する統計情報の作成、提供又は販売のため<br />
ウ 本サービス及び本サービスを活用して、管理者が行う実証的取組の評価のため<br />
(3) ユーザは、取得情報について、本サービスの提供に係るシステムに一時的に蓄積されることを承諾します。<br />
(4) ユーザは、前項に規定する取得情報について、個人を特定できない総体的かつ統計的な情報に加工した上で、管理者が自ら利用することを承諾します。<br />
(5) 本サービスは、Google Maps Platform及びGoogle Analyticsのモジュールを組み込んでおり、管理者は、検索条件、IPアドレス及び緯度・経度の座標情報をGoogle LLCへ提供する場合があります。 ユーザは、前項の定めによるほか、Google LLCの定めるプライバシーポリシーに従い、 Google LLC及びその関連会社がGoogleのサービス及びサービスを提供・改善するために、本サービスの利用に係る取得情報を使用し、保持することを承諾します。<br />
(6) 管理者は、取得情報について次の各号のとおり共同利用を行います。<br />
ア 共同利用する情報<br />
(ｱ) 操作情報<br />
(ｲ) 利用履歴<br />
(ｳ) ６(1)に規定の取得情報<br />
イ 共同ユーザの範囲<br />
(ｱ) 調布スマートシティ協議会<br />
(ｲ)	カフェウォーカー ※地域情報サイト「多摩ポン」運営者<br />
ウ 利用目的<br />
６(2)に規定の利用目的<br />
エ 情報管理についての責任を有する者の名称<br />
調布市
</p>
<h2 class="font-bold text-link_darker">７．本サービスに関する問い合わせ及びユーザへの通知</h2>
<p>(1) ユーザは管理者に対し、本サービスを通じて本サービスに関する意見・問い合わせをすることができます。<br />
(2) 本サービスを通じて寄せられたご意見・お問い合わせは管理者の代表である調布市が一次的に確認、対応するものとします。いただいたお問い合わせのうち、回答が必要なものについては、調布市から、原則２週間以内に回答するものとします。<br />
(3) 本サービスを通じて寄せられたご意見・お問い合わせの中に個人情報（回答に必要な、質問者の連絡先等の情報を含む）が含まれている場合、調布市がその情報を適正に管理するものとします。調布市がお預かりした個人情報は、お問い合わせに対する回答以外には利用しません。<br />
(4) 本サービスを通じて寄せられたご意見・お問い合わせの内容は、個人が特定されない状態にしたうえで、管理者及び管理者が必要と認める第三者に共有する場合があります。<br />
(5) 本サービスを運営する上で生じる事象に関する通知は、本サービス上にて行うものとします。 
</p>
<h2 class="font-bold text-link_darker">８．本サービスの変更</h2>
<p>(1) 管理者は、本サービスの品質向上及び改善に必要と判断した場合、ユーザに事前に通知することなく、本サービスの全部又は一部を変更することがあります。<br />
(2) 本サービスの変更により本サービスを利用するための端末を調整する必要が生じた場合、その費用はユーザが負担するものとします。<br />
(3) 本サービスの変更によりユーザが何らかの損害を被ったとしても、管理者は一切の責任を負わないものとします。
</p>
<h2 class="font-bold text-link_darker">９．本サービスの中断</h2>
<p>(1) 管理者は、次の各号のいずれかに該当する場合、ユーザに事前に通知することなく、本サービスの提供を中断することができるものとします。<br />
ア 本サービスのシステム保守を定期的に、又は緊急に行う場合<br />
イ 火災、停電、戦争、暴動、騒乱、労働争議などにより本サービスの提供ができなくなった場合<br />
ウ 地震、噴火、洪水、津波などの天災により本サービスの提供ができなくなった場合<br />
エ 本サービスに用いる通信サービスが停止し、又は障害が発生した場合<br />
オ 本サービス対応端末の使用環境その他の事情により通信障害が生じた場合<br />
カ その他、運用上又は技術上、管理者が本サービスの提供を一時的に中断する必要があると判断した場合<br />
(2) 管理者は、本サービス用設備等の定期点検を行うため、ユーザに事前に通知の上、本サービスの提供を一時的に中断できるものとします。<br />
(3) 前二項に定める事由のいずれかに該当して本サービスを提供できなかったことにより、ユーザが何らかの損害を被ったとしても、管理者は一切の責任を負わないものとします。
</p>
<h2 class="font-bold text-link_darker">１０．本サービスの提供及び本規約の終了</h2>
<p>(1) 管理者は、次の各号のいずれかに該当する場合、本サービスの提供を終了することができるものとします。本サービスの提供が終了する場合、本規約は本サービスの提供終了と同時に終了します。<br />
ア 提供終了日の１ヶ月前までにユーザに通知した場合<br />
イ 天災地変等の不可抗力により本サービスを提供できない場合<br />
ウ 令和８（2026）年２月２８日を過ぎた場合<br />
(2) 前項に基づき本サービスを廃止することにより、ユーザが何らかの損害を被ったとしても、管理者は一切の責任を負わないものとします。
</p>
<h2 class="font-bold text-link_darker">１１．ユーザの責任</h2>
<p>(1) 本サービスを構成するコンテンツの正確性・信頼性・安全性・完全性・有用性については、ユーザの責任にて判断するものとします。ユーザが本サービスを利用した行為がユーザの特定目的に合致するか否かについても同様とします。<br />
(2) インターネットは完全な通信手段ではなく、それを用いる本サービスもインターネットの有するリスクを保有します。本サービスを利用する際に生じる通信の秘匿性は必ずしも保証されないことをあらかじめ承諾し、ユーザの判断と責任にて本サービスを利用するものとします。<br />
(3) ユーザが本サービスを利用することによりユーザと第三者との間で生じた紛争については、ユーザの責任と負担にてかかる紛争に対応するものとします。
</p>
<h2 class="font-bold text-link_darker">１２．注意事項</h2>
<p>(1) ユーザは、本サービスを利用するにあたり、以下の事項を遵守するものとします。 <br />
ア 車両の運転中又は歩行中の本サービス対応端末の操作や画面の注視は危険を伴い、道路交通法その他の法令に違反する可能性があるため、安全な場所で本サービスを利用する。<br />
イ 本サービスが提供する情報は参考情報であること、また、必ずしも常に最適なものになるとは限らないことを認識し、実際の歩道や道路の状況、道路標識、道路標示、及び、その他の交通規制や交通ルールに従う。<br />
ウ ユーザは、本サービスの申込情報を送信するにあたって、管理者又は個別サービス事業者の定める手順・セキュリティ手段を遵守する。<br />
(2) この遵守を怠った場合、管理者はその結果について一切の責任を負いません。
</p>
<h2 class="font-bold text-link_darker">１３．禁止事項</h2>
<p>(1) ユーザは、本サービスの利用にあたり、以下に定める行為を行わないものとします。<br />
ア 管理者もしくは第三者の著作権、商標権等の知的財産権、その他の権利を侵害する行為、又は侵害するおそれのある行為<br />
イ 第三者のプライバシーを侵害する行為、又は侵害するおそれのある行為<br />
ウ 第三者に本サービスを利用させることにより、第三者に位置情報を取得させる行為<br />
エ 本サービスへの不正アクセス、不正攻撃又はそのおそれのある行為<br />
オ 本サービスの提供を不能にすること、その他本サービスの提供及びその運営に支障を与える行為、又はそのおそれのある行為<br />
カ 管理者もしくは第三者に不利益もしくは損害を与える行為、又はそのおそれのある行為<br />
キ 犯罪的行為もしくは犯罪的行為に結びつく行為、又はそのおそれのある行為<br />
ク 本サービスを利用することによって得られる一切の情報を業として利用する行為又は方法の如何を問わず第三者の利用に供する行為<br />
ケ 本サービスを本サービス対応端末以外の端末（本サービス対応端末を不正に改造した端末を含みます。）で利用する行為<br />
コ 本サービスの逆コンパイル、逆アセンブル等のリバースエンジニアリング行為<br />
サ RPA・Bot・クローラその他のプログラム等、人の手以外での入力操作<br />
シ 本規約に違反する行為<br />
ス 上記の他、法令、もしくは公序良俗に違反する行為、又は違反するおそれのある行為<br />
(2) ユーザは、本サービス及び個別サービスに係る契約上の地位の全部又は一部を第三者に譲渡、承継、又は担保に供することはできません。
</p>
<h2 class="font-bold text-link_darker">１４．知的財産権等</h2>
<p>本サービスを構成するコンテンツの著作権等の知的財産権その他一切の権利は、管理者及び当該権利を有する第三者に帰属します。</p>
<h2>１５．損害賠償</h2>
<p>(1) 管理者は、本サービスの内容及びユーザが本サービスを通じて得る情報等について、 その内容の真偽、正確性、最新性、有用性、信頼性、適法性、第三者の権利を侵害していないことについては、いかなる保証もいたしません。 <br />
(2) ユーザが本サービス又は個別サービスの利用によって第三者に対して損害を与えた場合、 ユーザは自己の責任と負担をもって解決するものとします。<br />
(3) ユーザが本規約又は個別サービスに係る規約に反した行為、又は不正もしくは違法な行為によって管理者に損害を与えた場合、 ユーザは、その損害を賠償する責めを負うものとします。 
</p>
<h2 class="font-bold text-link_darker">１５．損害賠償</h2>
<p>(1) 管理者は、本サービスの内容及びユーザが本サービスを通じて得る情報等について、 その内容の真偽、正確性、最新性、有用性、信頼性、適法性、第三者の権利を侵害していないことについては、いかなる保証もいたしません。 <br />
(2) ユーザが本サービス又は個別サービスの利用によって第三者に対して損害を与えた場合、 ユーザは自己の責任と負担をもって解決するものとします。<br />
(3) ユーザが本規約又は個別サービスに係る規約に反した行為、又は不正もしくは違法な行為によって管理者に損害を与えた場合、 ユーザは、その損害を賠償する責めを負うものとします。 
</p>
<h2 class="font-bold text-link_darker">１６．GPS取得精度についての免責</h2>
<p>本サービス対応端末に搭載されるGPS機能は、衛星からの電波を利用しているため、建物の中、高層ビル群地帯、高圧線の近く、密集した樹木の近くではGPSの電波を受信しにくい、もしくは受信できない場合があり、このような場合は基地局の情報のみを用いて位置の測位を行います。 また、基地局の設置状況又は本サービス対応端末の電波状況により基地局情報を正確に取得することができない場合があります。 これらの場合、位置情報と実際の位置に大きな誤差が生じることや、位置情報を得られないことがあります</p>
<h2 class="font-bold text-link_darker">１７．免責</h2>
<p>(1) ユーザと個別サービス事業者との間で紛争が生じた場合は、ユーザと当該個別サービス事業者との間で解決するものとし、ユーザは、管理者に何らの請求又は苦情を申し立てないものとします。 <br />
(2) ユーザは、次の各号の場合には、本サービス及び個別サービスの全部又は一部が利用できず、それによりユーザ又は第三者が被った損害・損失等に対して、 それが管理者の故意又は重過失により生じた場合を除き、管理者がいかなる責任も負わないものであることを承諾します。<br />
ア ユーザの届出た情報の内容に誤りのある場合<br />
イ 本サービス対応端末又はその他周辺機器等が正しく設置もしくは接続されていない場合、故障、損壊、不具合等があり正常に作動しない場合、通信環境の故障、損壊、不具合等があり正常に通信できない場合、これらの組み合わせにおいて不適合である場合、又は本サービスもしくは個別サービスの利用に障害となるような機能設定をしている場合<br />
ウ 本サービス対応端末又はその他周辺機器の取扱説明書等に記載されている事項を遵守しなかった場合<br />
エ 本サービス対応端末の電池切れ等、端末又はその他周辺機器等に電力が正常に供給されていない場合<br />
オ 本サービス対応端末又はその他周辺機器等の電源が入っていない場合
</p>
<h2 class="font-bold text-link_darker">１８．準拠法・合意管轄</h2>
<p>本規約の準拠法は日本法とし、本規約及び提供サービスに関する法的紛争の一切に関しては、東京地方裁判所立川支部を第一審の専属的合意管轄裁判所とします。</p>
<h2 class="font-bold text-link_darker">１９．協議等</h2>
<p>(1) ユーザと管理者との間で本規約の解釈その他につき疑義が生じた場合には、両当事者は誠意をもって協議し解決に努めるものとします。<br />
(2) 本規約の一部が法令に基づいて無効と判断されても、その他の部分は有効とします。<br />
(3) 本規約の一部があるユーザとの関係で無効又は取り消された場合でも、その他のユーザとの関係では本規約を有効とします。
</p>
</div>
<div class="mt-4">
    <button @click="backTop" class="back_button">
      <span class="w-full -ml-5">戻る</span>
    </button>
  </div>
</div>
</template>
  
  <script>
  
  export default {
    name: 'Terms',
    methods: {
      backTop: function () {
        this.$router.push({ name: 'root', params: { lang: this.lang } })
      }
    }
  }
  </script>

  
<style lang="scss" scoped>

.title{
  display: block;
  font-size: 16px;
  font-style: normal;
  line-height: 130%;
  color: #313234;
}

.message-box{
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
    grid-gap: 6px;
    gap: 6px;
}
.labels {
  display: flex;
  grid-gap: 8px;
  gap: 8px;
}

.article {
  margin: 0 12px;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  word-break: break-all;
  border-radius: 8px;
  background-color: #fff;
  grid-gap: 16px;
  gap: 16px;
}

.link{
  color: #2F8DB7;
  font-weight: bold;
  text-decoration: underline;
}
.back_button{
  margin-top: 24px;
  margin-right: 16px;
  margin-left: 16px;
  display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 16px;
    height: 52px;
    width: calc(100% - 32px);
    padding: 0 12px;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;
    border: 1px solid #313234;
    border-radius: 100px;
    background-color: #fff;
    color: #313234;
}
</style>